//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql

import com.apollographql.apollo.annotations.ApolloAdaptableWith
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.Mutation
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.adapter.UpsertInspectionMutation_ResponseAdapter
import com.wintermar.inspection.graphql.adapter.UpsertInspectionMutation_VariablesAdapter
import com.wintermar.inspection.graphql.selections.UpsertInspectionMutationSelections
import com.wintermar.inspection.graphql.type.UpsertInspectionCommandInput
import kotlin.Any
import kotlin.Boolean
import kotlin.String
import com.wintermar.inspection.graphql.type.Mutation as CompiledMutation

public data class UpsertInspectionMutation(
  public val upsertInspectionCommandInput: UpsertInspectionCommandInput,
) : Mutation<UpsertInspectionMutation.Data> {
  override fun id(): String = OPERATION_ID

  override fun document(): String = OPERATION_DOCUMENT

  override fun name(): String = OPERATION_NAME

  override fun serializeVariables(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    UpsertInspectionMutation_VariablesAdapter.serializeVariables(writer, this, customScalarAdapters, withDefaultValues)
  }

  override fun adapter(): Adapter<Data> = UpsertInspectionMutation_ResponseAdapter.Data.obj()

  override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = CompiledMutation.type
  )
  .selections(selections = UpsertInspectionMutationSelections.__root)
  .build()

  @ApolloAdaptableWith(UpsertInspectionMutation_ResponseAdapter.Data::class)
  public data class Data(
    public val upsertInspection: UpsertInspection,
  ) : Mutation.Data

  public data class UpsertInspection(
    public val lastUpdatedAt: Any?,
  )

  public companion object {
    public const val OPERATION_ID: String =
        "2cb124b5a14ee4cd590a37217ed17b3c6936e4cdf8f5f943c583fb76e623285c"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * ```
     * mutation upsertInspection($upsertInspectionCommandInput: UpsertInspectionCommandInput!) {
     *   upsertInspection(command: $upsertInspectionCommandInput) {
     *     lastUpdatedAt
     *   }
     * }
     * ```
     */
    public val OPERATION_DOCUMENT: String
      get() = "mutation upsertInspection(${'$'}upsertInspectionCommandInput: UpsertInspectionCommandInput!) { upsertInspection(command: ${'$'}upsertInspectionCommandInput) { lastUpdatedAt } }"

    public const val OPERATION_NAME: String = "upsertInspection"
  }
}
